// extracted by mini-css-extract-plugin
module.exports = {"Token":"ShareScreen__Token__2Lk2x","pulse":"ShareScreen__pulse__2A11j","Link":"ShareScreen__Link__2G8Lm","MainImg":"ShareScreen__MainImg__1n4eI"};